import { useEffect } from "react";
import applyAnchor from "@oddbird/css-anchor-positioning/fn";
import t from "../locales";

function anchorSupported() {
  return "anchorName" in document.documentElement.style;
}

export default function DropdownFilter({
  id,
  label,
  options,
  value,
  onChange,
}) {
  const menuId = `${id}-menu`;

  useEffect(() => {
    if (!anchorSupported()) applyAnchor();
  }, []);

  return (
    <div className="dropdown-filter">
      <button
        className="dropdown-filter__trigger"
        type="button"
        command="toggle-popover"
        commandfor={menuId}
      >
        {label}
        <svg
          className="dropdown-filter__icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M6 9L12 15L18 9" />
        </svg>
      </button>
      <div className="dropdown-filter__menu" id={menuId} popover="auto">
        <label className="dropdown-filter__option">
          <input
            className="dropdown-filter__checkbox"
            type="checkbox"
            checked={options.every((option) => value.includes(option.id))}
            onChange={(event) =>
              onChange(
                event.target.checked ? options.map((option) => option.id) : [],
              )
            }
          />
          {t("dropdown-filter.select-all")}
        </label>
        {options.map((option) => (
          <label key={option.id} className="dropdown-filter__option">
            <input
              className="dropdown-filter__checkbox"
              type="checkbox"
              checked={value.includes(option.id)}
              onChange={(event) =>
                onChange(
                  event.target.checked
                    ? [...value, option.id]
                    : value.filter((id) => id !== option.id),
                )
              }
            />
            {option.name}
          </label>
        ))}
      </div>
    </div>
  );
}
